import { closeBtn } from 'icons/close';
import './mediaPreview.scss';

export const MediaPreviewTemplate = (model) => {
	const { id, children } = model;

	/* html */
	const html = `
        <div
            class="engt-preview-close engt-tab-selectable" 
            id="engtPreviewClose"
            onkeydown="ENGT_CHAT.onEnterPress()"
            tabindex="2"
            >
				${closeBtn('#403f42')}
        </div>
        <div class="engt-preview-content" id='engtContent'>
            ${children}
        </div>
    `;

	return html;
};
